module.exports = __webpack_public_path__ + "static/media/recycle.51f3ed20.svg";